import { request } from "./apiRequest";
import type { AboutParagraph } from "../types/about.types";

export const aboutClient = {
  getParagraphs: () => request<AboutParagraph[]>("/about"),

  addParagraph: (text: string) =>
    request<AboutParagraph>("/about/admin", {
      method: "POST",
      body: JSON.stringify({ text }),
    }),

  updateParagraph: (id: string, text: string) =>
    request<AboutParagraph>(`/about/admin/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: JSON.stringify({ text }),
    }),

  deleteParagraph: (id: string) => request<void>(`/about/admin/${encodeURIComponent(id)}`, { method: "DELETE" }),
};
